import { useState } from "react";

import generateOptOutSearchFormProperty from "./generateOptOutSearchFormProperty";

const OptOutSearchFormProperty = ({ handlePropertySearch }) => {

  const [brandId, setBrandId] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("")
  const [zip, setZip] = useState("")

  const clearFields = () => {
    setBrandId('');
    setState('');
    setCity('');
    setAddressLine1('');
    setAddressLine2('');
  } 
  
  return (
    <div
      className="search-form-box opt-out-search"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >

      {generateOptOutSearchFormProperty(
        brandId, setBrandId,
        addressLine1, setAddressLine1,
        addressLine2, setAddressLine2,
        city, setCity,
        state, setState,
        zip, setZip,
      )}

      <button
        onClick={() => {
          handlePropertySearch(brandId, addressLine1, addressLine2, city, state, zip)
        }} // do some validation then send to dynamo
        
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      <button
        onClick={() =>
          clearFields()
        }
        className="subBtn"
      >
        <span>Clear All Fields</span>
      </button>
    </div>
  );
};

export default OptOutSearchFormProperty;